import React, { createContext, useContext, useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

// KINOS Helpdesk theme context.
// Workspace pages default to LIGHT; user can flip to DARK via header toggle.
// Login / CSAT public pages are NOT wrapped by this — they always stay dark for brand.

const ThemeContext = createContext({
  theme: "light",
  setTheme: () => {},
});

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    try {
      const stored = localStorage.getItem("kinos_theme");
      return stored === "dark" ? "dark" : "light";
    } catch { return "light"; }
  });

  useEffect(() => {
    try { localStorage.setItem("kinos_theme", theme); } catch { /* noop */ }
  }, [theme]);

  const setTheme = (t) => setThemeState(t === "dark" ? "dark" : "light");

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const next = theme === "dark" ? "light" : "dark";
  const Icon = theme === "dark" ? Sun : Moon;
  return (
    <button
      onClick={() => setTheme(next)}
      data-testid="theme-toggle-btn"
      title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      className="inline-flex items-center gap-1.5 px-2 py-1 border border-slate-800 rounded-sm text-slate-400 hover:text-white hover:border-slate-600 transition-colors"
    >
      <Icon className="h-3 w-3" strokeWidth={1.5} />
      <span className="text-[10px] font-mono uppercase tracking-[0.2em]">
        {theme === "dark" ? "Light" : "Dark"}
      </span>
    </button>
  );
}
